((app, ng) => {

    app.component("planningDirectoryButton",
        {
            template: `
                <md-button ng-click="$ctrl.openPlanningDirectory($event)" class="md-icon-button btn-accent">
                    <md-icon md-font-icon="mdi mdi-24px mdi-folder" aria-label="Open File Viewer"></md-icon>
                    <md-tooltip md-delay="500">Open File Viewer</md-tooltip>
                </md-button>
            `,
            controller: planningDirectoryButtonController,
            bindings: {
                caseid: "<",
                user: "<",
                client: "<"
            }
        });

    function planningDirectoryButtonController(fileViewerModalService) {
        const $ctrl = this;

        const openPlanningDirectory = ($event) => {
            fileViewerModalService.openPlanningDirectory($ctrl.caseid, $ctrl.user, $ctrl.client, $event);
        }

        ng.extend($ctrl,
            {
                openPlanningDirectory,
            });
    }

})(window.app, window.angular);